<template>
  <div>
    <form class="form" id="update_cellphone_request">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              تغییر شماره همراه
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="request()"
              ref="update_cellphone_request_btn"
            >
              تایید
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label text-alert">
              شماره همراه
            </label>
            <div class="col-lg-9 col-xl-6">
              <the-mask
                mask="09PP PPP PP PP"
                v-model="form.cellphone"
                :tokens="maskTokens"
                :masked="false"
                name="cellphone"
                ref="cellphone"
                placeholder="09__ ___ __ __"
                class="form-control form-control-lg form-control-solid mb-2 text-center"
                dir="ltr"
                autocomplete="off"
              ></the-mask>
            </div>
          </div>
        </div>
      </div>
    </form>
    <form class="form" id="update_cellphone_submit" style="display: none">
      <!--begin::Card-->
      <div class="card card-custom">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title">
            <h3 class="card-label font-weight-bolder text-dark">
              تغییر شماره همراه
            </h3>
          </div>
          <div class="card-toolbar">
            <button
              type="button"
              class="btn btn-sm btn-primary mr-2"
              @click="submit()"
              ref="update_cellphone_submit_btn"
            >
              ارسال
            </button>
            <button
              type="reset"
              class="btn btn-sm btn-secondary"
              @click="stopTimer"
            >
              بازگشت
            </button>
          </div>
        </div>
        <!--end::Header-->
        <div class="card-body">
          <div class="form-group row">
            <label class="col-xl-3 col-lg-3 col-form-label text-alert">
              کد
            </label>
            <div class="col-lg-9 col-xl-6">
              <input
                name="otp"
                ref="otp"
                class="form-control form-control-solid text-center h-auto p-5 rounded-lg"
                type="text"
              />
            </div>
          </div>
          <div class="text-right">
            <div class="timer">{{ prettyTime(time) }}</div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {
  UPDATE_CELLPHONE_REQUEST,
  UPDATE_CELLPHONE_SUBMIT
} from "@/core/services/store/profile.module";

import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import { TheMask } from "vue-the-mask";

export default {
  name: "ChangeCellphone",
  data() {
    return {
      off: "off",
      time: 0,
      timer: null,
      form: {
        cellphone: ""
      }
    };
  },
  components: {
    TheMask
  },
  mounted() {
    const update_cellphone_request = document.getElementById(
      "update_cellphone_request"
    );

    const update_cellphone_submit = document.getElementById(
      "update_cellphone_submit"
    );

    this.fv = formValidation(update_cellphone_request, {
      fields: {
        cellphone: {
          validators: {
            notEmpty: {
              message: "شماره همراه خود را وارد کنید"
            },
            stringLength: {
              min: 14,
              message: "شماره همراه صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
    this.fv2 = formValidation(update_cellphone_submit, {
      fields: {
        otp: {
          validators: {
            notEmpty: {
              message: "کد را وارد کنید"
            },
            regexp: {
              regexp: /[0-9]|[\u06F0-\u06F9]|[\u0660-\u0669]*/i,
              message: "کد صحیح نیست"
            },
            stringLength: {
              min: 6,
              max: 6,
              message: "کد صحیح نیست"
            }
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        bootstrap: new Bootstrap()
      }
    });
  },
  methods: {
    request() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let cellphone = this.parsePhone(this.form.cellphone);

          const submitButton = this.$refs["update_cellphone_request_btn"];
          this.disableBtn(submitButton);

          this.$store
            .dispatch(UPDATE_CELLPHONE_REQUEST, { cellphone })
            .then(response => {
              this.time = response["expires_after"];
              this.startTimer();
              this.showForm("submit");

              this.enableBtn(submitButton);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا شماره همراه را به طور صحیح وارد نمایید");
        }
      });
    },
    submit() {
      this.fv.validate().then(status => {
        if (status === "Valid") {
          let cellphone = this.parsePhone(this.form.cellphone);
          let otp = this.parseNumbers(this.$refs.otp.value);

          const submitButton = this.$refs["update_cellphone_submit_btn"];
          this.disableBtn(submitButton);

          this.$store
            .dispatch(UPDATE_CELLPHONE_SUBMIT, {
              cellphone: cellphone,
              otp: otp
            })
            .then(() => {
              this.showForm("request");
              this.enableBtn(submitButton);
            })
            .catch(() => {
              this.enableBtn(submitButton);
            });
        } else if (status === "Invalid") {
          this.showError("لطفا کد را به طور صحیح وارد نمایید");
        }
      });
    },
    startTimer() {
      if (!this.timer) {
        this.timer = setInterval(() => {
          if (this.time > 0) {
            this.time--;
          } else {
            this.stopTimer();
          }
        }, 1000);
      }
    },
    stopTimer() {
      clearInterval(this.timer);
      this.timer = null;
      this.time = 0;
      this.showForm("request");
    },

    showForm(name) {
      const update_cellphone_request = document.getElementById(
        "update_cellphone_request"
      );
      const update_cellphone_submit = document.getElementById(
        "update_cellphone_submit"
      );

      if (name === "submit") {
        update_cellphone_request.style.display = "none";
        update_cellphone_submit.style.display = "block";
      } else {
        update_cellphone_request.style.display = "block";
        update_cellphone_submit.style.display = "none";
      }
    }
  }
};
</script>
